const UTM_SOURCES = ['gha', 'Google Hotel Ads']

const utmSources =
  (utmSources: string[]) => (source: string | null | undefined) => {
    const defaultSource = 'other'
    return source && utmSources.includes(source) ? source : defaultSource
  }

export default utmSources(UTM_SOURCES)
